export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const CLEAR_AUTH_NOTIFICATIONS = 'CLEAR_AUTH_NOTIFICATIONS';
export const FETCH_GALLERY = 'FETCH_GALLERY';
export const FETCH_GALLERY_SUCCESS = 'FETCH_GALLERY_SUCCESS';
export const FETCH_GALLERY_FAILURE = 'FETCH_GALLERY_FAILURE';
export const FETCH_ASSET_INDEX = 'FETCH_ASSET_INDEX';
export const FETCH_ABOUT_CONFIG = 'FETCH_ABOUT_CONFIG';
export const UPDATE_GALLERY_CONFIG = 'UPDATE_GALLERY_CONFIG';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js